export enum GiftTypeReward {
    NONE,
    COINS = "coins"
}
